<div class="menu-list-item expandable" (click)="toggle()">
  <div class="details">
    <div class="details-header">
      <ng-content select="[header]"></ng-content>
    </div>
    <div class="details-body" [class.open]="open">
      <ng-content select="[body]"></ng-content>
    </div>
  </div>
</div>
